import React from "react";
import { Box } from "@mui/material";
import { Props } from "./Props";
import EditPictureStyles from "./EditPictureStyles";

const EditPictureIcon: React.FC<Props> = ({ fill, src, otherProps }) => {
  const { width, height } = otherProps;
  return (
    <Box sx={EditPictureStyles.mainBox}>
      <Box sx={EditPictureStyles.innerBoxForProfile}>
        <Box sx={EditPictureStyles.svgPhotoBorder}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 141 141"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M70.5 138.5C108.055 138.5 138.5 108.055 138.5 70.5C138.5 32.9446 108.055 2.5 70.5 2.5C32.9446 2.5 2.5 32.9446 2.5 70.5C2.5 108.055 32.9446 138.5 70.5 138.5ZM70.5 141C109.436 141 141 109.436 141 70.5C141 31.5639 109.436 0 70.5 0C31.5639 0 0 31.5639 0 70.5C0 109.436 31.5639 141 70.5 141Z"
              fill={fill}
            />
          </svg>
        </Box>
        <Box sx={EditPictureStyles.svgPhoto}>
          <img src={src} alt="profile pic" />
        </Box>
      </Box>
      <Box sx={EditPictureStyles.cameraImage}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="54"
          height="54"
          viewBox="0 0 54 54"
          fill="none"
        >
          <g filter="url(#filter0_d_3025_5786)">
            <circle cx="27" cy="25" r="24" fill="white" />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.5651 14.5H29.4349C29.5529 14.5 29.6339 14.5 29.7096 14.5046C30.6736 14.563 31.5178 15.1714 31.8781 16.0675C31.9064 16.1379 31.932 16.2147 31.9693 16.3267L31.9743 16.3419C32.0186 16.4748 32.0342 16.5208 32.0498 16.5595C32.2659 17.0972 32.7724 17.4622 33.3508 17.4973C33.3923 17.4998 33.4449 17.5 33.5944 17.5L33.63 17.5C33.9654 17.5 34.1726 17.5 34.3451 17.5171C36.0052 17.6815 37.3185 18.9948 37.4829 20.6549C37.5 20.8274 37.5 21.0254 37.5 21.3442V29.2222C37.5 30.0435 37.5 30.6905 37.4575 31.2111C37.4141 31.7423 37.3239 32.1859 37.1185 32.589C36.783 33.2475 36.2475 33.783 35.589 34.1185C35.1859 34.3239 34.7423 34.4141 34.2111 34.4575C33.6905 34.5 33.0435 34.5 32.2222 34.5H21.7778C20.9565 34.5 20.3095 34.5 19.7889 34.4575C19.2577 34.4141 18.8141 34.3239 18.411 34.1185C17.7525 33.783 17.217 33.2475 16.8815 32.589C16.6761 32.1859 16.5859 31.7423 16.5425 31.2111C16.5 30.6905 16.5 30.0435 16.5 29.2222L16.5 21.3442C16.5 21.0254 16.5 20.8274 16.5171 20.6549C16.6815 18.9948 17.9948 17.6815 19.6549 17.5171C19.8274 17.5 20.0346 17.5 20.37 17.5C20.3817 17.5 20.3936 17.5 20.4056 17.5C20.5551 17.5 20.6077 17.4998 20.6492 17.4973C21.2276 17.4622 21.7341 17.0972 21.9502 16.5595C21.9658 16.5208 21.9814 16.4748 22.0257 16.3419L22.0307 16.3266C22.068 16.2147 22.0936 16.1379 22.1219 16.0675C22.4822 15.1714 23.3264 14.563 24.2904 14.5046C24.3661 14.5 24.4471 14.5 24.5651 14.5ZM24.5811 15.5C24.4411 15.5 24.3925 15.5002 24.3508 15.5027C23.7724 15.5378 23.2659 15.9028 23.0498 16.4405C23.0342 16.4792 23.0186 16.5252 22.9743 16.6581L22.9693 16.6734C22.932 16.7853 22.9064 16.8621 22.8781 16.9325C22.5178 17.8286 21.6736 18.437 20.7096 18.4954C20.6338 18.5 20.5485 18.5 20.4233 18.5L20.4056 18.5C20.0236 18.5 19.8701 18.5006 19.7535 18.5122C18.5677 18.6297 17.6297 19.5677 17.5122 20.7535C17.5006 20.8703 17.5 21.0149 17.5 21.3772V29.2C17.5 30.0483 17.5004 30.6545 17.5392 31.1297C17.5776 31.599 17.6509 31.8963 17.7725 32.135C18.0122 32.6054 18.3946 32.9878 18.865 33.2275C19.1037 33.3491 19.401 33.4224 19.8703 33.4608C20.3455 33.4996 20.9517 33.5 21.8 33.5H32.2C33.0483 33.5 33.6545 33.4996 34.1297 33.4608C34.599 33.4224 34.8963 33.3491 35.135 33.2275C35.6054 32.9878 35.9878 32.6054 36.2275 32.135C36.3491 31.8963 36.4224 31.599 36.4608 31.1297C36.4996 30.6545 36.5 30.0483 36.5 29.2V21.3772C36.5 21.0149 36.4994 20.8703 36.4878 20.7535C36.3703 19.5677 35.4323 18.6297 34.2465 18.5122C34.1299 18.5006 33.9764 18.5 33.5944 18.5L33.5767 18.5C33.4515 18.5 33.3662 18.5 33.2904 18.4954C32.3264 18.437 31.4822 17.8286 31.1219 16.9325C31.0936 16.8621 31.068 16.7853 31.0307 16.6733L31.0257 16.6581C30.9814 16.5252 30.9658 16.4792 30.9502 16.4405C30.7341 15.9028 30.2276 15.5378 29.6492 15.5027C29.6075 15.5002 29.5589 15.5 29.4189 15.5H24.5811ZM27 22C25.067 22 23.5 23.567 23.5 25.5C23.5 27.433 25.067 29 27 29C28.933 29 30.5 27.433 30.5 25.5C30.5 23.567 28.933 22 27 22ZM22.5 25.5C22.5 23.0147 24.5147 21 27 21C29.4853 21 31.5 23.0147 31.5 25.5C31.5 27.9853 29.4853 30 27 30C24.5147 30 22.5 27.9853 22.5 25.5Z"
            fill="black"
          />
          <defs>
            <filter
              id="filter0_d_3025_5786"
              x="0"
              y="0"
              width="54"
              height="54"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="1.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_3025_5786"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_3025_5786"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </Box>
    </Box>
  );
};

export default EditPictureIcon;
